const hooks = [];

// To return true, all functions must return true.
function add(fnc) {
  hooks.push(fnc);
}

function run(Section) {
  hooks.forEach(hook => hook(Section));
}

const service = {
  run,
  add
};

window.hideSectionHookService = service;

module.exports = service;
